<template>
  <div class="l-row">
    <form-group v-for="(attribute, index) in attributes" :key="attribute" :label="attribute.name" :columns="4" :required="attribute.tags && attribute.tags.required || attribute.attributeUsedAsVariation" v-if="(!attribute.tags || !attribute.tags.fixed) && attribute.id !== 'SELLER_SKU' && attribute.id !== 'SIZE_GRID_ROW_ID'" :error="getError(attribute.id, errorIndex)">
      <select class="form-select" v-model="product.attributes[attribute.id]" v-if="isSelectWithId(attribute) && Object.keys(custom).indexOf(attribute.id) === -1" @change="onChangeAttribute(attribute.id, product.attributes[attribute.id])">
        <option :value=null>{{ $t('choose.label') }}</option>
        <option v-for="attributeValue in attribute.values" :key="attributeValue" :value="attributeValue.id">{{ attributeValue.name }}</option>
      </select>

      <div v-else-if="isSelectWithId(attribute) && Object.keys(custom).indexOf(attribute.id) !== -1">
        <select class="form-select" v-model="product.attributes[attribute.id]" v-if="!custom[attribute.id]" @change="onChangeAttribute(attribute.id, product.attributes[attribute.id])">
          <option :value=null>{{ $t('choose.label') }}</option>

          <optgroup :label="$t(`custom.${attribute.id.toLowerCase()}.label`)">
            <option value="custom" v-if="Object.keys(custom).indexOf(attribute.id) !== -1">Adicionar personalizada</option>
            <option v-for="attributeValue in attribute.values" :key="attributeValue" :value="attributeValue.id" v-if="attributeValue.custom">{{ attributeValue.name }}</option>
          </optgroup>

          <optgroup :label="$t(`default.${attribute.id.toLowerCase()}.label`)">
            <option v-for="attributeValue in attribute.values" :key="attributeValue" :value="attributeValue.id" v-if="!attributeValue.custom">{{ attributeValue.name }}</option>
          </optgroup>
        </select>

        <span v-else>
          <editable value="" :isEditable="true" :onConfirm="(a, b) => onConfirmAttribute(a, b, attribute.id)" :onCancel="() => onCancelAttribute(attribute.id)"/>
        </span>
      </div>

      <input class="form-input" type="text" v-model="product.attributes[attribute.id]" v-else-if="!attribute.default_unit">
      <div class="form-flex" v-else>
        <input class="form-input" type="text" v-model="product.attributes[attribute.id]">
        <span class="form-addon">
          <select v-model="attribute.default_unit" class="form-select form-select--sm">
            <option :value="unit.id" v-for="unit in attribute.allowed_units">{{ unit.name }}</option>
          </select>
        </span>
      </div>

    </form-group>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Editable from '@/components/template/Editable/Base'

  export default {
    data: () => ({
      custom: {
        COLOR: false,
        SIZE: false
      }
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      attributes: {
        type: Array,
        required: true
      },
      sourceVariation: {
        type: Object,
        required: true
      }
    },
    beforeMount () {
      for (let i in Object.keys(this.custom)) {
        const attributeId = Object.keys(this.custom)[i]

        const attributeCategory = this.attributes.find(attribute => attribute.id === attributeId)

        if (this.product.attributes[attributeId] !== null && attributeCategory !== undefined && attributeCategory.values !== undefined) {
          const attributeValue = attributeCategory.values.find(value => value.id === this.product.attributes[attributeId] || value.name === this.product.attributes[attributeId] || value.id === this.sourceVariation.attributes[attributeId.toLowerCase()])

          if (attributeValue !== undefined) {
            this.product.attributes[attributeId] = attributeValue.id
          }
        }
      }

      for (let j in this.attributes) {
        if (this.attributes[j].id === 'GTIN') {
          if (this.product.attributes['GTIN'] === null) {
            this.product.attributes['GTIN'] = this.sourceVariation.ean
          }
        }
      }
    },
    methods: {
      isSelectWithId (attribute) {
        return !!attribute.values
      },
      onChangeAttribute (attributeId, value) {
        if (Object.keys(this.custom).indexOf(attributeId) === -1 || value !== 'custom') {
          return false
        }

        this.custom[attributeId] = true
      },
      onConfirmAttribute (oldValue, newValue, attributeId) {
        this.attributes.find(attribute => attribute.id === attributeId).values.push({ id: newValue, name: newValue, custom: true })
        this.product.attributes[attributeId] = newValue

        this.custom[attributeId] = false
      },
      onCancelAttribute (attributeId) {
        this.product.attributes[attributeId] = null
        this.custom[attributeId] = false
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      errorIndex () {
        return this.product.sku ? this.product.sku : this.product.productId
      }
    },
    watch: {
      'product.attributes' (value) {
        this.product.attributes = value
      }
    },
    components: {
      Panel,
      FormGroup,
      Editable
    }
  }
</script>

<style lang="sass" scoped>
  .form-input,
  .form-select:not(.form-select--sm)
    height: 42px
</style>



// WEBPACK FOOTER //
// Attributes.vue?1bec88f6